import { HttpClient } from '@angular/common/http'
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core'
import { DataTableDirective } from 'angular-datatables'
import { PATH } from 'src/app/app.api'
import { Subject } from 'rxjs'
import { getLoggedUser } from 'src/app/_helpers/LocalStorage'
import { UserAdmin } from 'src/app/models/UserAdmin'
import { ActivatedRoute } from '@angular/router'
import { NotificationService } from 'src/app/services/notification.service'
import { Requesters } from 'src/app/models/Requester'
import { UserService } from 'src/app/services/user.service'

@Component({
	selector: 'app-requesters',
	templateUrl: './requesters.component.html'
})
export class RequestersComponent implements OnInit, AfterViewInit {

		@ViewChild(DataTableDirective) public dtElement: DataTableDirective

		public refreshTable: Subject<any> = new Subject()
	public datatableOptions: DataTables.Settings = {}

		public sessionUser: UserAdmin = getLoggedUser()

		public filterText: string = ''
	public updateDataTable = value => this.filterHeader(value)

	public requesters: Array<Requesters> = []
	public requesterSelected: Requesters

	public openModalDemandsOfRequester: boolean = false

		constructor(
		private readonly notificationService: NotificationService,
		private readonly userService: UserService,
	 private readonly http: HttpClient,
		private readonly activateRoute: ActivatedRoute
		) {}

		public ngAfterViewInit(): void {
		this.refreshTable.next()
	}

		public async ngOnInit(): Promise<void> {

				this.filterText =
			this.activateRoute.snapshot.queryParams.search ? this.activateRoute.snapshot.queryParams.search : ''

				await this.setupDatatables()
		}

		private setupDatatables(): void {
		this.datatableOptions = {
			pagingType: 'full_numbers',
			language: {
				processing: 'Processando...',
				lengthMenu: '_MENU_ resultados por página',
				info: 'Mostrando de _START_ até _END_ de _TOTAL_ registros',
				infoEmpty: 'Mostrando 0 até 0 de 0 registros',
				infoFiltered: '',
				infoPostFix: '',
				zeroRecords: '...',
				loadingRecords: 'Cargando...',
				emptyTable: 'Nenhum registro encontrado',
				paginate: {
					first: 'Primero',
					previous: 'Anterior',
					next: 'Próximo',
					last: 'Último'
				},
				aria: {
					sortAscending: ': Ordenar colunas de forma ascendente',
					sortDescending: ': Ordenar colunas de forma ascendente'
				}
			},
			paging: true,
			searching: true,
			ordering: true,
			destroy: true,
			info: true,
			autoWidth: false,
			pageLength: 10,
			lengthChange: false,
			columnDefs: [
				{
					targets: [1],
					width: '.1%'
				}
			],
			order: [[1, 'desc']],
			orderMulti: true,
			serverSide: true,

			ajax: (dataTablesParameters: any, callback) => {
				this.http
					.get<any>(`${PATH}/requester-panel/list?&skip=${dataTablesParameters.start}&limit=${dataTablesParameters.length}&order=${dataTablesParameters.columns[dataTablesParameters.order[0].column].data}&typeOrder=${dataTablesParameters.order[0].dir}&search=${this.filterText}`)
					.subscribe(resp => {
						this.requesters = resp.content
						callback({
							recordsFiltered: resp.numberOfPages,
							recordsTotal: resp.numberOfPages,
							data: []
						})
					})
			},
			columns: [
				{ data: 'actions' , orderable: false },
				{ data: 'name' },
				{ data: 'cpf' },
				{ data: 'email' },
				{ data: 'telephone' },
				{ data: 'address' },
				{ data: 'ip' }
			]
		}
	}

	public openDemandsOfRequester(requester: Requesters) {
		this.requesterSelected = requester
		this.openModalDemandsOfRequester = true
	}

	public closeDemandsOfRequester() {
		this.requesterSelected = null
		this.openModalDemandsOfRequester = false
	}

	public async changeRequesterStatus(requester: Requesters) {

		try {
			const response: string =
				await this.userService.changeRequesterStatus(requester.idMongo).toPromise()

			this.notificationService.notify(response, 200)
		} catch (error) {
			this.notificationService.notify('Erro ao atualizar Status do requerente', 500)
		}

		requester.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
	}

		public filterHeader(value: string): void {
		this.filterText = value
	}

		public async rerender(): Promise<void> {
		if (this.dtElement.dtInstance) {
			this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
				document.querySelector('table').classList.add('hide')
				dtInstance.destroy()
				this.refreshTable.next()
				setTimeout(() => {
					document.querySelector('table').classList.remove('hide')
				}, 500)
			})
		} else {
			this.refreshTable.next()
		}
	}
}
